import { Component, OnInit, HostListener } from '@angular/core';
import { RestApiService } from "../shared/restApiServices/restapi.service";
import { Router , ActivatedRoute} from '@angular/router';
import { PlanService } from "../shared/services/planService";

@Component({
  selector: 'app-price',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.css']
})
export class PriceComponent implements OnInit {

  priceList = [];
  notSupportedSize : boolean;
  rightPanel:any;

  FAQs= [
    { "How does Ank Aha’s SurveyMan work?" :
    "The SurveyMan platform consists of an online web portal and surveyor apps for android and iOS devices. \
    The account owner can invite “Managers” to the online web portal to create surveys. Owner can also assign surveys created by him or other managers.\
    Surveyors download the app on their devices and sign up with their mobile numbers. \
    Owner/Managers can add Surveyors to the their account using their Mobile Numbers and organise them into Teams. \
    The surveys are assigned to the teams, and the respective surveyors can then see the survey’s in the mobile apps as soon as they “Refresh”. \
    Surveyors do not need internet connection to fill responses once the survey has been downloaded.\
    Once they have filled in the responses, surveyor will “Sync” responses as soon he gets access to internet and the responses will get updated in the web portal. \
    The surveys can also be filled online via Survey Link."},

    { "How do device limitations work?" :
    "The only commodity we charge for is the number of devices you use in your account. \
    You can create unlimited surveys with unlimited questions, add unlimited managers and surveyors to your account, and except the free plan, get unlimited responses to your surveys. \
    Once an assigned surveyor logs in to his account, his device gets added to your allocated pool of devices. If your pool of devices is already full, the surveys will be “Locked” on the additional devices that assigned surveyors log on to, and they will not be able to open the survey and fill responses. \
    If a device is not used (does not login) for a period of 30 consecutive days, the device automatically gets removed from the pool."},

    { "What are limitations of a free trial?" :
    "The free trial allows you to conduct surveys on only one device, with a maximum cap of 100 responses. \
    You can create unlimited surveys with unlimited questions, add unlimited managers and surveyors to your account. \
    You can upgrade your account at any time to get access to more devices."},

    { "How our monthly billing works?" :
    "SurveyMan has prepaid billing. You pay for the plan with allotted number of devices upfront for a month. \
    For example, if you subscribe to our “Large” plan on 17th July at 4 PM for 50 devices, your subscription for 50 devices will be valid till the midnight of 16th of August.  \
    After that, your subscription will get auto-renewed and your provided card will get charged – in the above example, on the morning of 17th August – and your subscription will be extended by 1-month."},

    { "How do cancel or stop auto-renewal of my subscription?" :
    "You can downgrade to the free plan anytime. In that case your subscription will not be auto-renewed. \
    Your plan will be immediately downgraded and you will only be able to access the surveys on one device."},

    { "Can I add new device licenses at anytime?" :
    "Yes. You can upgrade your plan to add additional devices at any time. \
    Your plan gets upgraded immediately and your subscription will be valid for 1 month from date of upgrade."},

    { "Do you have any contracts or cancellation fees?" :
    "No. We do not have any contracts or cancellation fees. You can downgrade to the free plan whenever you want."},

    { "Do you have a setup cost?":
    "Absolutely not. Our pricing plans do not have any setup fees or hidden gimmicks."},

    { "What payment methods are accepted?":
    "SurveyMan accepts monthly and annual subscription payments by Mastercard, Visa and American Express."},

    { "When I will be charged on the card?":
    "Your card will be charged on the day of your purchase date of every month."},

   { "Anything special for NGOs and educational institutions?":
    "Yes! We offer special offers including FREE ACCESS for the right causes. Please contact us with details of your project and organisation.\
     We would be happy to consider your request."}
  ]

  constructor(private restApiService: RestApiService, private router: Router, private planService :PlanService) {
    if (window.screen.width < 900) {
      // console.log("Screen size not supported");
      this.notSupportedSize = true;
    }
    else {
      this.notSupportedSize = false;
    }

    this.restApiService.getAllPlansData().subscribe(res=>{
       if(res && res.success == true){
         this.priceList = res.data;
       }
       else{
          console.log('No Plans data available');
       }
    })
   }

  ngOnInit() {
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth < 900) {
      this.notSupportedSize = true;
    }
    else{
      this.notSupportedSize=false;
    }
  }

  selectPlan(plan){
    this.planService.setPlan(plan);
    this.router.navigateByUrl('/signUp');
  }

  navigateToDashBoard() {
    this.router.navigateByUrl('/home');
  }

}



// WEBPACK FOOTER //
// ./src/app/price/price.component.ts